import React from 'react';
import Layout from '../../Components/Layout';
import { useSelector } from 'react-redux';
import { Box, Card, CardContent, Typography, Stack, Chip, IconButton, Tooltip, Button, Grid, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, TextField, InputAdornment, IconButton as MIconButton } from '@mui/material';

function Packages() {
    const { userpackageinfos } = useSelector((state) => state.auth);

    return (
        <Layout>
        <Box sx={{mt: 3, px: 2 }}>
        <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
            Packages
            </Typography>
            <Grid container spacing={2} sx={{ alignItems: 'stretch' }}>
            
            {/* Package detail */}
            <Grid size={{ xs: 12, lg: 6 }} sx={{ height: '100%' }}>
                <Card elevation={3} sx={{ borderRadius: 2, mb: 3 }}>
                <CardContent>
                    {userpackageinfos ? (
                    <Stack spacing={2}>
                        <Stack direction="row" alignItems="center" justifyContent="space-between">
                        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>Current Package</Typography>
                        <Chip size="small" label={userpackageinfos.status} color={userpackageinfos.status === 'active' ? 'success' : 'default'} />
                        </Stack>
                        <Stack direction="row" alignItems="center" justifyContent="space-between">
                        <Typography variant="body2" color="text.secondary">Name</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>{userpackageinfos.package?.name || '—'}</Typography>
                        </Stack>
                        <Stack direction="row" alignItems="center" justifyContent="space-between">
                        <Typography variant="body2" color="text.secondary">Price</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>${userpackageinfos.package?.price ?? '—'} / {userpackageinfos.package?.cycle || '—'}</Typography>
                        </Stack>
                        <Stack direction="row" alignItems="center" justifyContent="space-between">
                        <Typography variant="body2" color="text.secondary">Package Date</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>{userpackageinfos?.createdAt ? new Date(userpackageinfos?.createdAt).toISOString().slice(0, 10) : '—'}</Typography>
                        </Stack>
                        <Stack direction="row" alignItems="center" justifyContent="space-between">
                        <Typography variant="body2" color="text.secondary">Calls Included</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>{userpackageinfos?.package?.calls_included ?? '—'}</Typography>
                        </Stack>
                        <Stack direction="row" alignItems="center" justifyContent="space-between">
                        <Typography variant="body2" color="text.secondary">Cost per call</Typography>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>${userpackageinfos?.package?.cost_per_call ?? '—'}</Typography>
                        </Stack>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            onClick={() => window.open('https://admin.shopify.com/store/dev-dl1961/apps/agentzena/app/pricing', '_blank', 'noopener')}
                        >
                            Upgrade
                        </Button>
                        </Box>
                    </Stack>
                    ) : (
                    <Stack spacing={2} alignItems="flex-start">
                        <Typography variant="body2" color="text.secondary">No package selected yet</Typography>
                        <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={() => window.open('https://admin.shopify.com/store/dev-dl1961/apps/agentzena/app/pricing', '_blank', 'noopener')}
                        >
                        Upgrade
                        </Button>
                    </Stack>
                    )}
                </CardContent>
                </Card>
            </Grid>
            </Grid>
        </Box>
        </Layout>
    );
}

export default Packages;
